var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view width-840"},[_c('div',{staticClass:"heading-1"},[_vm._v(" Today's Most Active Students ")]),_c('MostActiveTable',{attrs:{"date":_vm.date,"type":"user-engagement-daily-analytics"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }